export default __webpack_public_path__ + "static/media/navlogo.b2c2d252b452cd16a2ff5507f89960bc.png";